module.exports = __webpack_public_path__ + "img/Cara_Verde.6e3dbf92.svg";